/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Approved_ActionInputs */

const en_wb_approved_action = /** @type {(inputs: Wb_Approved_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example approved ✓`)
};

const lv_wb_approved_action = /** @type {(inputs: Wb_Approved_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piemērs apstiprināts ✓`)
};

/**
* | output |
* | --- |
* | "Example approved ✓" |
*
* @param {Wb_Approved_ActionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_approved_action = /** @type {((inputs?: Wb_Approved_ActionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Approved_ActionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_approved_action(inputs)
	return en_wb_approved_action(inputs)
});